import { ToastMessage } from '@ajgre/toolkit';
import { TOAST_FEATURE_KEY } from '@cmi/store/toast';
import { createFeatureSelector } from '@ngrx/store';

export const selectToastMessages = createFeatureSelector<ToastMessage[]>(TOAST_FEATURE_KEY);
